// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file maintenance_task.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file maintenance_task.proto.
 */
export const file_maintenance_task: GenFile = /*@__PURE__*/
  fileDesc("ChZtYWludGVuYW5jZV90YXNrLnByb3RvEgZkb21haW4qhAYKD01haW50ZW5hbmNlVGFzaxIcChhNQUlOVEVOQU5DRV9UQVNLX1VOS05PV04QABI5CjVNQUlOVEVOQU5DRV9UQVNLX09SR0FOSVpBVElPTl9QUkVMSU1JTkFSWV9QUk9GSUxFU19WMxAMEi4KKk1BSU5URU5BTkNFX1RBU0tfUFJPQ0VTU19WQVVMVF9NRVNTQUdFU19WMhALEjQKME1BSU5URU5BTkNFX1RBU0tfRU5BQkxFX1BSRl9PUFBPUlRVTklTVElDQUxMWV9WMRAOEkQKQE1BSU5URU5BTkNFX1RBU0tfT1JHQU5JWkFUSU9OX1BFUkZPUk1fTUFJTlRFTkFOQ0VfSUZfRElTQUJMRURfVjEQEhIvCitNQUlOVEVOQU5DRV9UQVNLX09SR0FOSVpBVElPTl9FTlRSQV9TWU5DX1YyEB0SLQopTUFJTlRFTkFOQ0VfVEFTS19MRUFLRURfUEFTU1dPUkRfQ0hFQ0tfVjIQGxIpCiVNQUlOVEVOQU5DRV9UQVNLX1RFQU1fU1lOQ19NRU1CRVJTX1YxEBYSKQolTUFJTlRFTkFOQ0VfVEFTS19URUFNX1NZTkNfTUVNQkVSU19WMhAgEjEKLU1BSU5URU5BTkNFX1RBU0tfVEVBTV9TWU5DX01FTUJFUlNfQkFDS0VORF9WMhAeEjUKMU1BSU5URU5BTkNFX1RBU0tfQ1JFQVRFX0RFTEVHQVRFRF9BRE1JTlNfVkFVTFRfVjIQHxIlCiFNQUlOVEVOQU5DRV9UQVNLX0xPR0lOX1NVTU1BUllfVjEQGBItCilNQUlOVEVOQU5DRV9UQVNLX1BBU1NXT1JEX1BPTElDWV9DSEVDS19WMhAcIgQIARABIgQIAhACIgQIAxADIgQICRAJIgQIERARIgQIBBAEIgQIBRAFIgQIChAKIgQIDRANIgQIDxAPIgQIBhAGIgQIBxAHIgQICBAIIgQIEBAQIgQIExATIgQIFBAUIgQIFRAVIgQIGRAZIgQIFxAXIgQIGhAaQjBaLmdpdGxhYi5jb20vY290ZWNoZGUvbW9ub3JlcG8vYmFja2VuZC9kb21haW4vcGJiBnByb3RvMw");

/**
 * * This is an enum of maintenance tasks, which map to tasks perfomed by client-core. They are
 * included in SyncUpdate as an allow list, serving as a "killswitch" for disabling outdated or
 * rogue maintenance tasks, independently of the release cycle.
 *
 * The two common expected changes are:
 * 1) Deprecating a task altogether. To do this, comment it out and mark the field number as
 * reserved.
 * 2) Creating a new "version" of a task, while disabling the previous. To do this, increase the
 * field number, mark the old field number as reserved, and increase the VX number in the name.
 *
 * @generated from enum domain.MaintenanceTask
 */
export enum MaintenanceTask {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: MAINTENANCE_TASK_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: MAINTENANCE_TASK_ORGANIZATION_PRELIMINARY_PROFILES_V3 = 12;
   */
  ORGANIZATION_PRELIMINARY_PROFILES_V3 = 12,

  /**
   * @generated from enum value: MAINTENANCE_TASK_PROCESS_VAULT_MESSAGES_V2 = 11;
   */
  PROCESS_VAULT_MESSAGES_V2 = 11,

  /**
   * @generated from enum value: MAINTENANCE_TASK_ENABLE_PRF_OPPORTUNISTICALLY_V1 = 14;
   */
  ENABLE_PRF_OPPORTUNISTICALLY_V1 = 14,

  /**
   * Special maintenance task to allow switching off maintenance of disabled orgs. 
   *
   * @generated from enum value: MAINTENANCE_TASK_ORGANIZATION_PERFORM_MAINTENANCE_IF_DISABLED_V1 = 18;
   */
  ORGANIZATION_PERFORM_MAINTENANCE_IF_DISABLED_V1 = 18,

  /**
   * @generated from enum value: MAINTENANCE_TASK_ORGANIZATION_ENTRA_SYNC_V2 = 29;
   */
  ORGANIZATION_ENTRA_SYNC_V2 = 29,

  /**
   * @generated from enum value: MAINTENANCE_TASK_LEAKED_PASSWORD_CHECK_V2 = 27;
   */
  LEAKED_PASSWORD_CHECK_V2 = 27,

  /**
   * Successor to MAINTENANCE_TASK_TEAM_SYNC_ORGANIZATION_MEMBERS_V3
   * The V1 task was changed in 1b84ec6 during its lifetime without increasing its version, which
   * led to fights between the old and new versions. Clients from 2026-09-07 run the new maintenance
   * task as V2. To cover the gap until that is rolled out we keep V1 around with a backend-side
   * client version gate.
   *
   * @generated from enum value: MAINTENANCE_TASK_TEAM_SYNC_MEMBERS_V1 = 22;
   */
  TEAM_SYNC_MEMBERS_V1 = 22,

  /**
   * @generated from enum value: MAINTENANCE_TASK_TEAM_SYNC_MEMBERS_V2 = 32;
   */
  TEAM_SYNC_MEMBERS_V2 = 32,

  /**
   * @generated from enum value: MAINTENANCE_TASK_TEAM_SYNC_MEMBERS_BACKEND_V2 = 30;
   */
  TEAM_SYNC_MEMBERS_BACKEND_V2 = 30,

  /**
   * @generated from enum value: MAINTENANCE_TASK_CREATE_DELEGATED_ADMINS_VAULT_V2 = 31;
   */
  CREATE_DELEGATED_ADMINS_VAULT_V2 = 31,

  /**
   * @generated from enum value: MAINTENANCE_TASK_LOGIN_SUMMARY_V1 = 24;
   */
  LOGIN_SUMMARY_V1 = 24,

  /**
   * @generated from enum value: MAINTENANCE_TASK_PASSWORD_POLICY_CHECK_V2 = 28;
   */
  PASSWORD_POLICY_CHECK_V2 = 28,
}

/**
 * Describes the enum domain.MaintenanceTask.
 */
export const MaintenanceTaskSchema: GenEnum<MaintenanceTask> = /*@__PURE__*/
  enumDesc(file_maintenance_task, 0);

